const priorityLanguages = ["ENG"];

export const sortLanguages = (countries) => countries.toSorted((a, b) => {
    // Check if either country is in the priority list
    const indexA = priorityLanguages.indexOf(a.value);

    const indexB = priorityLanguages.indexOf(b.value);

    // Sort priority countries first
    if (indexA > -1 && indexB > -1) {
        return indexA - indexB; // Maintain the order in priority list
    }
    if (indexA > -1) return -1; // a is a priority country, put it first
    if (indexB > -1) return 1; // b is a priority country, put it first

    // If neither are in the priority list, sort alphabetically by label
    return (a.label).localeCompare(b.label);
});
